export function normalizePracticeId(value) {
    if (typeof value !== 'number' && typeof value !== 'string') return null;

    const normalized = typeof value === 'string' ? value.trim() : value;
    if (normalized === '') return null;

    const numeric = Number(normalized);
    return Number.isSafeInteger(numeric) && numeric > 0 ? numeric : null;
}

export function resolveContactPracticeId({ lead, practiceId } = {}) {
    const practiceObjectId = lead?.practice && typeof lead.practice === 'object'
        ? lead.practice.id
        : null;
    const scalarPractice = lead?.practice && typeof lead.practice !== 'object'
        ? lead.practice
        : null;
    const candidates = [
        lead?.practiceId,
        lead?.practice_id,
        practiceObjectId,
        scalarPractice,
        practiceId,
    ];

    return candidates.reduce(
        (resolved, candidate) => resolved ?? normalizePracticeId(candidate),
        null
    );
}
